import {
  RESPONSE_NAV,
  NODE_SELECTED,
  SET_HIGHLIGHT,
  SET_SECONDMENU_NAVITEMS,
  SET_SECONDMENU_VISIBILITY,
  SET_SECONDMENU_CURRENT_SELECTED,
  SET_SECONDMENU_SUBITEM_SELECTED,
  SET_TEMPORARY_MAIN_SELECTED,
  SET_NAVIGATION_PARAMS,
} from './constants';

const initialState = {
  nodeList: [],
  current: '',
  highlights: {},
  showSecondMenu: false,
  secondMenuItems: [],
  currentSelected: null,
  subItemSelected: null,
  temporaryMain: null,
  navigationParams: null,
};

export default function nav(state = initialState, action) {
  switch (action.type) {
    case RESPONSE_NAV:
      return {
        ...state,
        nav_type: action.nav.nav_type,
        nodeList: action.nav.nodes,
      };
    case SET_HIGHLIGHT:
      return {
        ...state,
        highlights: {
          ...state.highlights,
          [action.nodeCode]: action.highlights,
        },
      };
    case NODE_SELECTED:
      return { ...state, current: action.nodeCode };
    case SET_SECONDMENU_NAVITEMS:
      return { ...state, secondMenuItems: action.items };
    case SET_SECONDMENU_VISIBILITY:
      return { ...state, showSecondMenu: action.show };
    case SET_SECONDMENU_CURRENT_SELECTED:
      return { ...state, currentSelected: action.item };
    case SET_SECONDMENU_SUBITEM_SELECTED:
      return { ...state, subItemSelected: action.item };
    case SET_TEMPORARY_MAIN_SELECTED:
      return { ...state, temporaryMain: action.item };
    case SET_NAVIGATION_PARAMS:
      return { ...state, navigationParams: action.parameters };
    default:
      return state;
  }
}
